import { render, staticRenderFns } from "./PointShadow.vue?vue&type=template&id=251b27f4&scoped=true"
import script from "./PointShadow.vue?vue&type=script&lang=js"
export * from "./PointShadow.vue?vue&type=script&lang=js"
import style0 from "./PointShadow.vue?vue&type=style&index=0&id=251b27f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b27f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('251b27f4')) {
      api.createRecord('251b27f4', component.options)
    } else {
      api.reload('251b27f4', component.options)
    }
    module.hot.accept("./PointShadow.vue?vue&type=template&id=251b27f4&scoped=true", function () {
      api.rerender('251b27f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deDrag/PointShadow.vue"
export default component.exports